import { useTranslation } from 'react-i18next';

import * as St from './LandingPageImage.styles';

const LANDING_PAGE_IMAGE_SRC = '/public/assets/images/LandingPageStaticImg.svg';

const LandingPageImage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <St.Container data-testid="landing-page-image">
      <St.Image
        src={LANDING_PAGE_IMAGE_SRC}
        alt={t('STORE_PAGE.LANDING_IMAGE_ALT')}
      />
    </St.Container>
  );
};

export default LandingPageImage;
